import css from "standard/css";

const style = css`
  .filter {
    display: flex;
    flex-wrap: wrap;
    gap: var(--spacing_inset-xs);
  }

  .filter__class {
    border: var(--border-width-hairline) solid var(--color-ocean);
    background-color: transparent;
    border-radius: 100px;
    color: var(--color-ocean);
    cursor: pointer;
    font-size: var(--font-size-xxs);
    font-weight: var(--font-weight-medium);
    font-family: var(--font-family-highlight);
    padding: var(--spacing-nano) var(--spacing_inset-xs); 
  }

  .filter__class[selected="true"] {
    background-color: var(--color-ocean);
    color: var(--color-pure-white);
  }

  .registeredUser__ul {
    display: flex;
    flex-direction: column;
    gap: var(--spacing_inset-xs);
    list-style-type: none;
  }

  .registeredUser__li {
    padding: var(--spacing_inset-nano) var(--spacing_inset-xs);
    justify-content: center;
    border: 1px solid var(--color-master-light);
    border-radius: var(--border-radius-sm);
    width: 100%;
    gap: var(--spacing_inset-nano);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .registeredUser__informations {
    gap: var(--spacing_inset-nano);
    display: flex;
    flex-direction: column;
  }

  .registeredUser__name {
    font-family: var(--font-family-base);
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-medium);
    color: var(--color-master-dark);
  }

  .registeredUser__email {
    font-family: var(--font-family-base);
    font-size: var(--font-size-nano);
    font-weight: var(--font-weight-regular);
    color: var(--color-master);
  }

  .registeredUser__actions {
    display: flex;
    gap: var(--spacing_inset-xs);
  }

  .registeredUser__deleteButton,
  .registeredUser__changeButton {
    align-items: center;
    position: relative;
    background-color: transparent;
    display: flex;
    justify-content: center;
    border: none;
    cursor: pointer;
    height: 42px;
    width: 42px;
  }

  .registeredUser__changePassword {
    color: black;
  }

  .registeredUser__delete {
    width: 16px;
    height: 16px;
  }

  .registeredUser__deleteButton::before,
  .registeredUser__changeButton::before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    height: 42px;
    top: 0;
    width: 42px;
  }
`;

export default style;
